import { useState } from 'react';

import { Icon } from '../../components/ui/Icon';
import { getFallbackAvatarBackground } from '../../utils/avatar-colors';
import type { Student } from '../../data/students';
import avatar01 from './assets/avatars/avatar-01.png';
import avatar02 from './assets/avatars/avatar-02.png';
import avatar03 from './assets/avatars/avatar-03.png';
import avatar04 from './assets/avatars/avatar-04.png';
import avatar05 from './assets/avatars/avatar-05.png';
import avatar06 from './assets/avatars/avatar-06.png';
import styles from './Page.module.css';

// 沿用移动端的演示性别配置绑定照片；按稳定 ID 关联，不随列表排序分配。
const portraits: Readonly<Record<string, string>> = {
  'student-sj00124': avatar03,
  'student-sj00125': avatar04,
  'student-sj00127': avatar01,
  'student-sj00126': avatar06,
  'student-sj00128': avatar02,
  'student-sj00131': avatar05,
};

export function StudentAvatar({ student }: { student: Student }) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const src = portraits[student.id];
  return <span aria-hidden="true" className={styles.avatar}>
    <span className={styles.avatarFace} style={{ backgroundColor: getFallbackAvatarBackground(student.id, 'student') }}>
      {src && src !== failedSrc ? <img alt="" onError={() => setFailedSrc(src)} src={src} /> : student.initials.charAt(0).toUpperCase()}
    </span>
    <span className={styles.genderBadge} data-gender={student.gender}>
      <Icon name={student.gender === '男' ? 'man' : 'woman'} size="xs" />
    </span>
  </span>;
}
